import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError } from "Utils";

export const getTrees = ({
  token,
  limit = 12,
  language = "fr",
  community,
  scope = "COMMUNITY",
  type = "Media",
  user
  //sourceToken = null
}) => {
  const requestUrl = `${TTP_API_URL}/media/category`;

  const fields = ["*"];

  let filter = [
    {
      property: "scope",
      value: scope,
      operator: "like"
    },
    {
      property: "type",
      value: type,
      operator: "eq"
    }
  ];

  if (community) {
    filter.push({
      property: "organization",
      value: community,
      operator: "eq"
    });
  }
  if (scope === "USER" && user) {
    filter.push({
      property: "user",
      value: user.id,
      operator: "eq"
    });
  }
  const sort = [
    {
      property: "counter",
      dir: "desc"
    }
  ];
  return axios
    .get(requestUrl, {
      // cancelToken: getLatestTopicsSourceToken.token,
      params: {
        access_token: token,
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        filter: JSON.stringify(filter),
        limit
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const saveTree = ({
  token,
  id,
  tree,
  community,
  scope = "COMMUNITY"
  //sourceToken = null
}) => {
  const requestUrl = `${TTP_API_URL}/media/category`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("organization", community.id);
  formData.append("tree", JSON.stringify(tree));
  formData.append("scope", scope);
  id && formData.append("id", id);

  return axios.post(requestUrl, formData);
};

export const deleteTree = ({ token, id }) => {
  const requestUrl = `${TTP_API_URL}/media/category/${id}`;
  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("_method", "delete");
  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/tree.js